import React, { useState, useEffect } from "react";
// import ReactDOM from 'react-dom';
import { useTranslation } from "react-i18next";
// import { THEME_DARK } from 'common/src/helpers/constants';
import { printAmount } from "common/src/helpers/functions";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { PaymentServer } from "common/src/helpers/connectors";
import { Redirect } from "react-router";
import { DepositStartingDialog } from "../modal/DepositStartingDialog";
import {
  QUERY_EDD_SOW_STATUS,
  QUERY_CHECK_EXPERIAN,
  QUERY_CREATE_KYCP,
  QUERY_ME_LOCKS,
  QUERY_GET_BANKTRANSFER_ALL,
} from "common/src/graphql/queries";
import { MUTATION_UPDATE_BANKTRANSFER } from "common/src/graphql/mutations";
import { useApolloClient } from "@apollo/client";
import DepositPredefined from "./DepositPredefined";
import {
  ColumnLeftAndRight,
  DepositCardNumber,
  DepositCCVCode,
  DepositChoseAccount,
  DepositColWrapper,
  DepositExpiryDate,
  DepositName,
  DepositNewAccount,
  DepositSavedAccount,
  DepositRow,
  DepositType,
  StyledBankTransfer,
  StyledBonusCode,
  StyledColPar,
  StyledDepositDialog,
  StyledDepositImage,
  StyledDepositDesciption,
  StyledBankName,
} from "../styledComponents/StyledDepositDialog";
import {
  InvalidFeedback,
  StyledFormRow,
} from "../styledComponents/AccountPage";
import {
  StyledButton,
  StyledCustomControlLabel,
  StyledFlexBetween,
  StyledInput,
  StyledSelect,
} from "../styledComponents/CommonStyledComponents";
import { StyledRow } from "../styledComponents/StyledActiveBonus";
import { DepositAndWithdrawalRow } from "../styledComponents/StyledDepositAndWithdrawal";
import FraudNetScript from "./FraudNetScript";
import { StyledCustomCheckboxWrapper } from "../styledComponents/StyledSignupLogin";
import FirstDepositBonusCodeDropdown from "./FirstDepositBonusCodeDropdown";

const DepositDialog = ({
  serverSetup,
  depositType,
  playerData,
  backAction,
  selectedImage,
  setSpinner,
  isMobile,
  isTablet,
  userAgent,
  setDepositStepIframe,
  setDepositStepFormAction,
  setDepositStep,
  bonusCode,
  inGame,
  pages,
  setDepositStepIframeParameters,
  setDepositStepIframeMethod,
  setDepositStepIframeWidth,
  setDepositStepIframeHeight,
  setDepositStepIframeSrcDoc,
  setPxDepositStart,
  description,
  // piqEncripter,
  skin,
  setPendingDepositID,
  showFirstDepositSelect,
}) => {
  const apolloClient = useApolloClient();
  const { t, i18n } = useTranslation();
  let location = useLocation();
  // const baseUrl = "/" + i18n.language;
  const { country, callcreditTime, kycpID } = playerData;
  // console.log("----country: " + country);
  const isUK = country === "gb" ? true : false;
  const isIR = country === "ie" ? true : false;
  const isSE = country === "se" ? true : false;
  const [supportRedirect, setSupportRedirect] = useState(false);
  const [savedAccounts, setSavedAccounts] = useState([]);
  const [savedAccountsVisible, setSavedAccountsVisible] = useState(false);
  const [validatedDepositStart, setValidatedDepositStart] = useState(false);
  const [fraudNetData, setFraudNetData] = useState({ f: "", s: "" });
  const [oneClick, setOneClick] = useState(skin === "yak");
  // const [fraudNetScript, setFraudNetScript] = useState(false)
  // console.log(fraudNetData)

  const defaultBankData = {
    id: -1,
    accountHolder: playerData.firstName + " " + playerData.lastName,
    accountNumber: "",
    iBan: "",
    bic: "",
    sortCode: "",
    bankName: "",
    bankCountry: "",
    clearingNumber: "",
    bankBranch: "",
    bankIFSC: "",
    bankAddress: "",
  };

  const [bankData, setBankData] = useState(defaultBankData);

  const {
    register,
    formState: { errors },
    handleSubmit,
    setFocus,
  } = useForm();
  const [showDepositStartingDialog, setShowDepositStartingDialog] =
    useState(false);
  const [predefinedAmount, setPredefinedAmount] = useState("");

  // useEffect(() => {
  //   //if payment is piq card, load their script
  //   if (
  //     depositType.depositType.indexOf("VISA PIQ") >= 0 ||
  //     depositType.depositType.indexOf("MasterCard PIQ") >= 0 ||
  //     depositType.depositType.indexOf("CreditCard PIQ") >= 0
  //   ) {
  //     const script = document.createElement("script");
  //
  //     script.src = piqEncripter;
  //     script.async = true;
  //
  //     document.body.appendChild(script);
  //
  //     return () => {
  //       document.body.removeChild(script);
  //     };
  //   }
  // }, [depositType]);

  useEffect(() => {
    inGame && setFocus("depositAmount");
  }, [setFocus, predefinedAmount]);

  useEffect(() => {
    const getBankData = async () => {
      if (depositType.depositType !== "iDEAL PIQ-ADYEN") {
        return "";
      }

      const { loading, errors, data } = await apolloClient.query({
        query: QUERY_GET_BANKTRANSFER_ALL,
      });

      if (loading) return <h3>Loading ...</h3>;
      if (errors) {
        // console.log("error");
        toast.error(t(errors[0].message), {
          position: "bottom-center",
        });
        return "error";
      }
      // console.log("EDD RESPONSE: " + JSON.stringify(data))
      let returnName = "";
      data.getAllBanktransfer.banktransfer.forEach((bankt) => {
        if (bankt.isActive) {
          setBankData({
            id: bankt.id,
            accountHolder: bankt.accountHolder,
            accountNumber: bankt.accountNumber,
            iBan: bankt.iBan,
            bic: bankt.bic,
            sortCode: bankt.sortCode,
            bankName: bankt.bankName,
            bankCountry: bankt.bankCountry,
            clearingNumber: bankt.clearingNumber,
            bankBranch: bankt.bankBranch,
            bankIFSC: bankt.bankIFSC,
            bankAddress: bankt.bankAddress,
          });
          returnName = bankt.bankName;
        }
      });
      return returnName;
    };

    const getOldCards = async (bankName) => {
      PaymentServer.post("/fhnd/v1/transaction/deposit/used-accounts", {
        depositType: depositType.depositType,
        paymentProvider: depositType.paymentProvider,
        userLocale: i18n.language,
      })
        .then((res) => {
          // console.log("OLD CARDS: " + JSON.stringify(res.data));
          if (res.data.usedAccounts) {
            if (
              depositType.depositType.indexOf("iDEAL PIQ-ADYEN") < 0 ||
              bankName !== ""
            ) {
              setSavedAccounts(res.data.usedAccounts);
              setSavedAccountsVisible(true);
              // if(res.data.usedAccounts[0]) {
              //   setFraudNetData({...fraudNetData, f: res.data.usedAccounts[0].FNSI, s: res.data.usedAccounts[0].SWI})
              // }
            }
          }

          if (
            depositType.depositType.indexOf("PayPal PIQ") >= 0 &&
            res.data.FNSI &&
            res.data.SWI
          ) {
            setFraudNetData({
              ...fraudNetData,
              f: res.data.FNSI,
              s: res.data.SWI,
            });
          }

          return true;
        })
        .catch(() => {
          return false;
        });
    };
    getBankData()
      .then((res) => {
        if (res === "error") {
          return;
        }
        if (
          (depositType.paymentProvider === "payment-iq" &&
            (depositType.depositType.indexOf("VISA PIQ") >= 0 ||
              depositType.depositType.indexOf("MasterCard PIQ") >= 0 ||
              depositType.depositType.indexOf("CreditCard PIQ") >= 0 ||
              depositType.depositType.indexOf("iDEAL PIQ-ADYEN") >= 0)) ||
          (depositType.depositType.indexOf("PayPal PIQ") >= 0 && oneClick)
        ) {
          setSpinner(true);
          getOldCards(res)
            .then(() => {
              setSpinner(false);
              // console.log("OLD CARDS: " + JSON.stringify(res));
            })
            .catch(() => {
              setSpinner(false);
              // console.log("OLD CARDS ERROR: " + JSON.stringify(error));
            });
        }
      })
      .catch(() => {
        return false;
      });
  }, [playerData, depositType, i18n.language, setSpinner, apolloClient, t]);

  const onSubmit = (data) => {
    // console.log("submit form:" + JSON.stringify(data));
    //show dialog
    if (country === "nl" && savedAccounts.length > 0 && !savedAccountsVisible) {
      window.location.replace(pages["support"]);
      return;
    }
    if (depositType.depositType === "Boku" && !validatedDepositStart) {
      // console.log("validate deposit amount for boku");
      setSpinner(true);
      let parameters = {
        amount: data.depositAmount && data.depositAmount.trim(),
        ip: serverSetup.geoIP.ipAddress,
        depositType: depositType.depositType,
        paymentProvider: depositType.paymentProvider,
      };

      PaymentServer.post("/fhnd/v1/transaction/deposit/validate", parameters)
        .then((res) => {
          // console.log(res);
          toast.success(t(res.data.message), {
            position: "bottom-center",
          });
          setValidatedDepositStart("true");
          setSpinner(false);
        })
        .catch((err) => {
          toast.error(t(err.response.data[0]), {
            position: "bottom-center",
          });
          setSpinner(false);
          return false;
        });
    } else {
      //validate visa and mc card numbers to avoid completing for ex. mastercard deposit with visa card
      //visa card numbers start with 4, mastercard with 2 or 5
      if (data.cardNumber && data.cardNumber.length > 1) {
        console.log("credit card");
        if (depositType.depositType.indexOf("VISA") >= 0) {
          if (Array.from(data.cardNumber)[0] !== "4") {
            toast.error(
              t(
                "error_invalid_visa_card_number",
                "error_invalid_visa_card_number"
              ),
              {
                position: "bottom-center",
              }
            );
            setSpinner(false);
            return false;
          }
        } else if (depositType.depositType.indexOf("MasterCard") >= 0) {
          if (
            Array.from(data.cardNumber)[0] !== "2" &&
            Array.from(data.cardNumber)[0] !== "5"
          ) {
            toast.error(
              t(
                "error_invalid_mastercard_card_number",
                "error_invalid_mastercard_card_number"
              ),
              {
                position: "bottom-center",
              }
            );
            setSpinner(false);
            return false;
          }
        }
      }

      setShowDepositStartingDialog(true);
      checkEddSow(data);
    }
  };

  const savedAccountsNewCard = () => {
    setSavedAccountsVisible(false);
  };

  const savedAccountsOldCard = () => {
    if (country === "nl" && savedAccounts.length > 0 && !savedAccountsVisible) {
      window.location.replace(pages["support"]);
    } else {
      setSavedAccountsVisible(true);
    }
  };

  const checkEddSow = async (depositParameters) => {
    const { loading, errors, data } = await apolloClient.query({
      query: QUERY_EDD_SOW_STATUS,
    });

    if (loading) return <h3>Loading ...</h3>;
    if (errors) {
      toast.error(t(errors[0].message), {
        position: "bottom-center",
      });
      setShowDepositStartingDialog(false);
      return false;
    }
    // console.log("EDD RESPONSE: " + JSON.stringify(data))
    if (data.eddSowStatus.ok) {
      experianCheck(depositParameters);
    } else {
      sessionStorage.setItem("user_banned_from_page", "eddsow");
      // window.location.replace(`${baseUrl}/support`);
      setSupportRedirect(true);
    }
  };

  const experianCheck = async (depositParameters) => {
    if (isUK) {
      //TODO: check if its already checked
      // console.log("callcredit: " + callcreditTime + " " + callcreditStatus)
      if (callcreditTime === "") {
        const { loading, errors, data } = await apolloClient.query({
          query: QUERY_CHECK_EXPERIAN,
        });

        if (loading) return <h3>Loading ...</h3>;
        if (errors) {
          toast.error(t(errors[0].message), {
            position: "bottom-center",
          });
          setShowDepositStartingDialog(false);
          return false;
        }

        if (data.checkExperian.lock) {
          sessionStorage.setItem("user_banned_from_page", "eddsow");
          // window.location.replace(`${baseUrl}/support`);
          setSupportRedirect(true);
        } else {
          kycCheck(depositParameters);
        }
      } else {
        //experian already checked, proceed
        kycCheck(depositParameters);
      }
    } else {
      //not uk, proceed
      kycCheck(depositParameters);
    }
  };

  const kycCheck = async (depositParameters) => {
    if (kycpID === "") {
      const { loading, errors } = await apolloClient.query({
        query: QUERY_CREATE_KYCP,
      });

      if (loading) return <h3>Loading ...</h3>;
      if (errors) {
        // toast.error(t(errors[0].message), {
        //   position: "bottom-center",
        // });
        // setShowDepositStartingDialog(false);
        // return false;
      }
      // console.log("KYCP RESPONSE: " + JSON.stringify(data))
      // if(data.createKycp.result) {
      //   experianCheck(depositParameters);
      // } else {
      //   sessionStorage.setItem("user_banned_from_page", "eddsow");
      //   window.location.replace(`${baseUrl}/support`);
      // }
      depositsAvailableCheck(depositParameters);
    } else {
      depositsAvailableCheck(depositParameters);
    }
  };

  const depositsAvailableCheck = async (depositParameters) => {
    const { loading, errors, data } = await apolloClient.query({
      query: QUERY_ME_LOCKS,
    });

    if (loading) return <h3>Loading ...</h3>;
    if (errors) {
      toast.error(t(errors[0].message), {
        position: "bottom-center",
      });
      setShowDepositStartingDialog(false);
      return false;
    }
    // console.log("DEPOSITS AVAILABLE RESPONSE: " + JSON.stringify(data));
    if (data.me.lockStatus.deposit) {
      sessionStorage.setItem("user_banned_from_page", "eddsow");
      // window.location.replace(`${baseUrl}/support`);
      setSupportRedirect(true);
    } else {
      startPayment(depositParameters);
    }
  };

  async function updateBankData(bankName) {
    // console.log("save bank data");
    if (bankName && bankName !== "" && bankData.id >= 0) {
      // console.log("save bank data mutation");
      const { loading, errors, data } = await apolloClient.mutate({
        mutation: MUTATION_UPDATE_BANKTRANSFER,
        variables: {
          bankID: bankData.id,
          bankName: bankName,
          accountHolder: bankData.accountHolder,
          accountNumber: bankData.accountNumber,
          iBan: bankData.iBan,
          bic: bankData.bic,
          sortCode: bankData.sortCode,
          bankCountry: bankData.bankCountry,
          clearingNumber: bankData.clearingNumber,
          bankBranch: bankData.bankBranch,
          bankIFSC: bankData.bankIFSC,
          bankAddress: bankData.bankAddress,
        },
      });

      if (loading) return "Loading ...";
      if (errors) {
        // toast.error(errors[0].message, {
        //   position: 'bottom-center',
        // });
        return false;
      }

      if (data.setBanktransfer.ok) {
        // toast.success(t('label_success'), {
        //   position: 'bottom-center',
        // });
      }
    }
  }

  const startPayment = (data) => {
    //tracking pixels
    setPxDepositStart(true);
    // console.log("data", data);
    // return;
    let parameters = {
      amount: data.depositAmount && data.depositAmount.trim(),
      depositType: depositType.depositType,
      paymentProvider: depositType.paymentProvider,
      cardNumber: data.cardNumber && data.cardNumber.trim(),
      expMonth: data.expiryDate && data.expiryDate.trim(),
      expYear: data.expiryYear && data.expiryYear.trim(),
      // cvv: data.cvcCode && data.cvcCode.trim(),
      encCvv: "",
      userLocale: i18n.language,
      netAccount: data.netellerAccount && data.netellerAccount.trim(),
      secureId: data.netellerSecureID && data.netellerSecureID.trim(),
      useOldCard: data.useOldCard,
      accId: savedAccountsVisible ? data.accId : "",
      depFirstName: data.firstName && data.firstName.trim(),
      depLastName: data.lastName && data.lastName.trim(),
      bonusCode:
        data.bonusCode && data.bonusCode === "proceed"
          ? ""
          : data.bonusCode && data.bonusCode.trim(),
      accountHolder: data.accountHolder && data.accountHolder.trim(),
      iban: data.iban && data.iban.trim(),
      bic: data.bic && data.bic.trim(),
      bankName:
        bankData.bankName === ""
          ? data.bankName && data.bankName.trim()
          : bankData.bankName,
      ip: serverSetup.geoIP.ipAddress,
      playerPhone: playerData.phone,
      domain: window.location.hostname,
      isMobile: isMobile || isTablet ? "true" : "false",
      userAgent: userAgent,
    };
    if (
      depositType.depositType.indexOf("VISA PIQ") >= 0 ||
      depositType.depositType.indexOf("MasterCard PIQ") >= 0 ||
      depositType.depositType.indexOf("CreditCard PIQ") >= 0
    ) {
      if (typeof window.encryptData !== "undefined") {
        if (!savedAccountsVisible) {
          parameters.encCardNumber = window.encryptData(data.cardNumber);
          parameters.cardNumber = "";
        }
        parameters.encCvv = window.encryptData(data.cvcCode.trim());
        parameters.cvv = "";
      } else {
        console.log("cvv encoder not available, abort!");
        toast.error(t("err_missing_parameters"), {
          position: "bottom-center",
        });
        setSpinner(false);
        return false;
      }
    }
    if (depositType.depositType.indexOf("iDEAL PIQ") >= 0) {
      if (savedAccountsVisible) {
        parameters.bankName = "";
      }
    }
    if (depositType.depositType.indexOf("PayPal PIQ") >= 0) {
      if (fraudNetData.f !== "" && oneClick) {
        parameters["fnsi"] = fraudNetData.f;
      }
    }
    // console.log("PARAMS: " + JSON.stringify(parameters));
    // setSpinner(true);
    // console.log("submit form:" + JSON.stringify(data));
    PaymentServer.post("/fhnd/v1/transaction/deposit", parameters)
      .then((res) => {
        //tracking pixels
        if (bankData.bankName === "") {
          updateBankData(parameters.bankName);
        }
        setShowDepositStartingDialog(false);
        // console.log("success: " + JSON.stringify(res.data.response));
        if (res.data.response.location === "redirect") {
          //iframe
          setSpinner(false);

          if (
            res.data.response.frame_height &&
            typeof res.data.response.frame_height === "number"
          ) {
            // console.log("set height: " + JSON.stringify(res.data.response.frame_height))
            setDepositStepIframeHeight(res.data.response.frame_height);
          }
          if (
            res.data.response.frame_width &&
            typeof res.data.response.frame_width === "number"
          ) {
            // console.log("set frame width: " + JSON.stringify(res.data.response.frame_width))
            setDepositStepIframeWidth(res.data.response.frame_width);
          }

          if (res.data.response.method && res.data.response.method.length) {
            // console.log("set method: " + JSON.stringify(res.data.response.method))
            setDepositStepIframeMethod(res.data.response.method);
          }

          if (res.data.response.parameters) {
            // console.log("set parameters: " + JSON.stringify(res.data.response.parameters))
            setDepositStepIframeParameters(res.data.response.parameters);
          }

          // if (
          //   depositType.paymentProvider === "trustly" &&
          //   (isMobile || isTablet)
          // ) {
          //   window.location.replace(res.data.response.url);
          // }
          if (res.data.response.url && res.data.response.url.length) {
            // console.log("set url: " + JSON.stringify(res.data.response.url))
            setDepositStepIframe(res.data.response.url);
          } else if (res.data.response.html && res.data.response.html.length) {
            // console.log("set html: " + JSON.stringify(res.data.response.html))
            setDepositStepIframeSrcDoc(res.data.response.html);
          }
          if (res.data.response.form_action && res.data.response.form_action) {
            setDepositStepFormAction(res.data.response.form_action);
          }
          if (setPendingDepositID && res.data.response.id) {
            console.log("--- set pending deposit id ----");
            setPendingDepositID(
              depositType.paymentProvider + "," + res.data.response.id
            );
          }
          // setDepositStepIframe("http://127.0.0.1:9001/en/dresponse/trustly/success-finish/parent")
          setDepositStep(2);
          setSpinner(false);
        } else if (res.data.response.location === "new_window") {
          if (
            res.data.response.frame_height &&
            typeof res.data.response.frame_height === "number"
          ) {
            // console.log("set height: " + JSON.stringify(res.data.response.frame_height))
            setDepositStepIframeHeight(res.data.response.frame_height);
          }
          if (
            res.data.response.frame_width &&
            typeof res.data.response.frame_width === "number"
          ) {
            // console.log("set width: " + JSON.stringify(res.data.response.frame_width))
            setDepositStepIframeWidth(res.data.response.frame_width);
          }

          if (res.data.response.method && res.data.response.method.length) {
            // console.log("set method: " + JSON.stringify(res.data.response.method))
            setDepositStepIframeMethod(res.data.response.method);
          }

          if (res.data.response.parameters) {
            // console.log("set parameters: " + JSON.stringify(res.data.response.parameters))
            setDepositStepIframeParameters(res.data.response.parameters);
          }

          if (res.data.response.url && res.data.response.url.length) {
            // console.log("set url: " + JSON.stringify(res.data.response.url))
            setDepositStepIframe(res.data.response.url);
          }
          if (res.data.response.form_action && res.data.response.form_action) {
            setDepositStepFormAction(res.data.response.form_action);
          }
          setDepositStep(5);
          setSpinner(false);
          //new window
        } else {
          //no redirect, do nothing (shouldn't happen)
          setSpinner(false);
        }
      })
      .catch((err) => {
        // if (depositType.depositType.indexOf("PayPal PIQ") >= 0 && savedAccountsVisible) {
        //   localStorage.removeItem(skin + "_pp_one_click")
        //   setOneClick(false)
        //   setSavedAccounts([])
        //   setSavedAccountsVisible(false)
        // }
        setShowDepositStartingDialog(false);
        //step back on error
        // console.log(errors.data)
        toast.error(t(err.response.data[0]), {
          position: "bottom-center",
        });
        setSpinner(false);
        return false;
      });
  };

  // console.log(JSON.stringify(errors));

  const months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

  const years = [];
  let yr = new Date().getFullYear();
  for (let i = yr; i <= yr + 10; i++) {
    years.push(i);
  }

  const nlBanks = [
    { name: "ABN_AMRO", code: "ABN_AMRO" },
    { name: "ASN", code: "ASN" },
    { name: "ING", code: "ING" },
    { name: "FREISLAND", code: "FREISLAND" },
    { name: "RABOBANK", code: "RABOBANK" },
    { name: "SNS", code: "SNS" },
    { name: "SNS_REGIO", code: "SNS_REGIO" },
    { name: "TRIODOS", code: "TRIODOS" },
    { name: "VAN_LANSCHOT", code: "VAN_LANSCHOT" },
    { name: "KNAB", code: "KNAB" },
    { name: "BUNQ", code: "BUNQ" },
    { name: "MONEYOU", code: "MONEYOU" },
  ];

  const fillDepositPredefined = (amount) => {
    // console.log("PREDEFINED SELECTED " + amount);
    setPredefinedAmount(amount);
  };

  const isNlNewAccountAvailable = () => {
    return (
      country !== "nl" ||
      savedAccounts.length === 0 ||
      savedAccountsVisible ||
      (depositType.depositType.indexOf("MasterCard PIQ") < 0 &&
        depositType.depositType.indexOf("VISA PIQ") < 0 &&
        depositType.depositType.indexOf("CreditCard PIQ") < 0 &&
        depositType.depositType.indexOf("iDEAL PIQ") < 0)
    );
  };

  const isQuickBetFirstDeposit = () => {
    if (showFirstDepositSelect) return true;
  };

  const saveOneClick = (enabled) => {
    // console.log("click", enabled)
    if (enabled) {
      localStorage.setItem(skin + "_pp_one_click", "saved");
    } else {
      localStorage.removeItem(skin + "_pp_one_click");
    }
    setOneClick(enabled);
  };

  if (supportRedirect) {
    return <Redirect to={pages["support"]}></Redirect>;
  }

  // console.log("register type: " + depositType.depositType)
  console.log(errors);

  return (
    <>
      <StyledDepositDialog
        onSubmit={handleSubmit(onSubmit)}
        racDeposit={location.pathname !== pages["deposit"]}
        inGame={inGame}
      >
        {!inGame && (
          <DepositAndWithdrawalRow dialogOpened={true}>
            <StyledDepositImage
              // id="visa"
              alt=""
              // height="100%"
              srcSet={selectedImage}
            />
            <DepositColWrapper>
              <StyledColPar col={"col-2"}>
                {t("label_transaction_time")}: {t(depositType.transactionTime)}
              </StyledColPar>{" "}
              <StyledColPar col={"col-2"}>
                {t("label_service_fee")}: {t(depositType.transactionFee)}
              </StyledColPar>{" "}
              <StyledColPar col={"col-2"}>
                {t("label_minimum_amount")}:{" "}
                {printAmount(
                  depositType.minimum,
                  playerData.currency,
                  serverSetup.currencies,
                  true
                )}
              </StyledColPar>
            </DepositColWrapper>
          </DepositAndWithdrawalRow>
        )}
        {inGame && depositType.depositType.indexOf("Bank Transfer") < 0 && (
          <DepositRow inGame={inGame}>
            <DepositPredefined
              currency={playerData.currency}
              currencies={serverSetup.currencies}
              setValue={fillDepositPredefined}
              skin={skin}
            ></DepositPredefined>
          </DepositRow>
        )}
        <StyledFormRow>
          {depositType.depositType.indexOf("Bank Transfer") < 0 &&
            isNlNewAccountAvailable() && (
              <DepositType
                typeofdata={
                  (depositType.depositType.indexOf("VISA") >= 0 ||
                    depositType.depositType.indexOf("MasterCard") >= 0 ||
                    depositType.depositType.indexOf("CreditCard") >= 0) &&
                  depositType.depositType.indexOf("MasterCard SE") < 0 &&
                  depositType.depositType.indexOf("VISA SE") < 0 &&
                  !savedAccountsVisible
                }
              >
                <label>{t("label_amount")}</label>
                <StyledInput
                  validform
                  type="number"
                  errorprop={errors.depositAmount}
                  defaultValue={predefinedAmount}
                  step="0.01"
                  {...register("depositAmount", {
                    required: t("err_empty_amount"),
                    min: {
                      value: parseFloat(depositType.minimum / 100),
                      message: t("err_invalid_minimum_amount"),
                    },
                    max: {
                      value: parseFloat(depositType.maximum / 100),
                      message: t("err_invalid_maximum_amount"),
                    },
                  })}
                ></StyledInput>
                <InvalidFeedback>
                  {errors.depositAmount?.message}
                </InvalidFeedback>
              </DepositType>
            )}
          {savedAccountsVisible && (
            <DepositChoseAccount>
              <label>{t("label_choose_account")}</label>
              <StyledSelect
                deposit={errors.expiryDate}
                name="accId"
                {...register("accId")}
              >
                {/*<option value=""></option>*/}
                {savedAccounts.map((account, index) => {
                  if (country !== "nl" || index === 0) {
                    return (
                      <option value={account.accountId} key={account.accountId}>
                        {account.cardType} {account.maskedAccount}
                      </option>
                    );
                  }
                })}
              </StyledSelect>
            </DepositChoseAccount>
          )}
          {savedAccountsVisible && (
            <DepositNewAccount>
              <label className="col-sm-12">&nbsp;</label>
              <StyledButton btn type="button" onClick={savedAccountsNewCard}>
                {t("label_new_account")}
              </StyledButton>
            </DepositNewAccount>
          )}
          {(depositType.depositType.indexOf("VISA") >= 0 ||
            depositType.depositType.indexOf("MasterCard") >= 0 ||
            depositType.depositType.indexOf("CreditCard") >= 0) &&
            depositType.depositType.indexOf("MasterCard SE") < 0 &&
            depositType.depositType.indexOf("VISA SE") < 0 &&
            !savedAccountsVisible &&
            isNlNewAccountAvailable() && (
              <DepositCardNumber>
                <label>{t("label_card_number")}</label>
                <StyledInput
                  validform
                  type="text"
                  errorprop={errors.cardNumber}
                  // onChange={e => validateCardNumber(e.target.value, depositType.depositType)}
                  {...register("cardNumber", {
                    required: t("err_empty_card_number"),
                    maxLength: {
                      value: 20,
                      message: t("err_invalid_length"),
                    },
                  })}
                ></StyledInput>
                <InvalidFeedback>{errors.cardNumber?.message}</InvalidFeedback>
              </DepositCardNumber>
            )}
          {(depositType.depositType.indexOf("VISA") >= 0 ||
            depositType.depositType.indexOf("MasterCard") >= 0 ||
            depositType.depositType.indexOf("CreditCard") >= 0) &&
            depositType.depositType.indexOf("MasterCard SE") < 0 &&
            depositType.depositType.indexOf("VISA SE") < 0 &&
            !savedAccountsVisible &&
            isNlNewAccountAvailable() && (
              <DepositExpiryDate>
                <label>{t("label_expiry_date")}</label>
                <StyledSelect
                  deposit={errors.expiryDate}
                  {...register("expiryDate", { required: t("err_empty_date") })}
                >
                  <option value=""></option>
                  {months.map((option) => {
                    return (
                      <option value={option} key={option}>
                        {option}
                      </option>
                    );
                  })}
                </StyledSelect>
                <InvalidFeedback>{errors.expiryDate?.message}</InvalidFeedback>
              </DepositExpiryDate>
            )}
          {(depositType.depositType.indexOf("VISA") >= 0 ||
            depositType.depositType.indexOf("MasterCard") >= 0 ||
            depositType.depositType.indexOf("CreditCard") >= 0) &&
            depositType.depositType.indexOf("MasterCard SE") < 0 &&
            depositType.depositType.indexOf("VISA SE") < 0 &&
            !savedAccountsVisible &&
            isNlNewAccountAvailable() && (
              <DepositExpiryDate>
                <label style={{ opacity: "0" }}>{t("label_expiry_date")}</label>
                <StyledSelect
                  deposit={errors.expiryYear}
                  {...register("expiryYear", { required: t("err_empty_date") })}
                  name="expiryYear"
                >
                  <option value=""></option>
                  {years.map((option) => {
                    return (
                      <option value={option} key={option}>
                        {option}
                      </option>
                    );
                  })}
                </StyledSelect>
              </DepositExpiryDate>
            )}
          {(depositType.depositType.indexOf("VISA") >= 0 ||
            depositType.depositType.indexOf("MasterCard") >= 0 ||
            depositType.depositType.indexOf("CreditCard") >= 0) &&
            depositType.depositType.indexOf("MasterCard SE") < 0 &&
            depositType.depositType.indexOf("VISA SE") < 0 &&
            isNlNewAccountAvailable() && (
              <DepositCCVCode savedAccountsVisible={savedAccountsVisible}>
                <label>{t("label_cvc_code")}</label>
                <StyledInput
                  validform
                  type="number"
                  errorprop={errors.cvcCode}
                  {...register("cvcCode", {
                    required: t("err_empty_cvv"),
                    maxLength: {
                      value: 4,
                      message: t("err_invalid_length"),
                    },
                  })}
                ></StyledInput>
                <InvalidFeedback>{errors.cvcCode?.message}</InvalidFeedback>
              </DepositCCVCode>
            )}
        </StyledFormRow>
        {(depositType.depositType.indexOf("VISA") >= 0 ||
          depositType.depositType.indexOf("MasterCard") >= 0 ||
          depositType.depositType.indexOf("CreditCard") >= 0) &&
          depositType.depositType.indexOf("MasterCard SE") < 0 &&
          depositType.depositType.indexOf("VISA SE") < 0 &&
          !savedAccountsVisible &&
          isNlNewAccountAvailable() && (
            <StyledFormRow>
              <DepositName>
                <label>{t("label_first_name")}</label>
                <StyledInput
                  validform
                  errorprop={errors.firstName}
                  type="text"
                  defaultValue={playerData.firstName}
                  {...register("firstName", {
                    maxLength: {
                      value: 40,
                      message: t("err_invalid_length"),
                    },
                  })}
                ></StyledInput>
                <InvalidFeedback>{errors.firstName?.message}</InvalidFeedback>
              </DepositName>
              <DepositName>
                <label>{t("label_last_name")}</label>
                <StyledInput
                  validform
                  errorprop={errors.lastName}
                  type="text"
                  defaultValue={playerData.lastName}
                  {...register("lastName", {
                    maxLength: {
                      value: 40,
                      message: t("err_invalid_length"),
                    },
                  })}
                ></StyledInput>
                <InvalidFeedback>{errors.lastName?.message}</InvalidFeedback>
              </DepositName>
            </StyledFormRow>
          )}
        {depositType.depositType.indexOf("Neteller") >= 0 &&
          !savedAccountsVisible && (
            <StyledFormRow>
              <DepositName>
                <label>{t("label_neteller_account")}</label>
                <StyledInput
                  validform
                  type="text"
                  errorprop={errors.netellerAccount}
                  {...register("netellerAccount", {
                    required: t("err_empty_account"),
                    maxLength: {
                      value: 40,
                      message: t("err_invalid_length"),
                    },
                  })}
                ></StyledInput>
                <InvalidFeedback>
                  {errors.netellerAccount?.message}
                </InvalidFeedback>
              </DepositName>
              <DepositName>
                <label>{t("label_neteller_secure_id")}</label>
                <StyledInput
                  validform
                  type="text"
                  errorprop={errors.netellerSecureID}
                  {...register("netellerSecureID", {
                    maxLength: {
                      value: 40,
                      message: t("err_invalid_length"),
                    },
                  })}
                ></StyledInput>
                <InvalidFeedback>
                  {errors.netellerSecureID?.message}
                </InvalidFeedback>
              </DepositName>
            </StyledFormRow>
          )}
        {depositType.depositType === "iDEAL PIQ-ADYEN" &&
          bankData.bankName === "" && (
            <StyledFormRow>
              <StyledBankName>
                <label>{t("label_bank")}</label>
                <StyledSelect
                  deposit={errors.bankName}
                  {...register("bankName", {
                    required: t("err_empty_bank_name", "err_empty_bank_name"),
                  })}
                  name="bankName"
                >
                  <option value=""></option>
                  {nlBanks.map((bank) => {
                    return (
                      <option value={bank.code} key={bank.code}>
                        {bank.name}
                      </option>
                    );
                  })}
                </StyledSelect>
                <InvalidFeedback>{errors.bankName?.message}</InvalidFeedback>
              </StyledBankName>
            </StyledFormRow>
          )}

        {!isNlNewAccountAvailable() && (
          <StyledDepositDesciption>
            {t("label_deposit_new_account_description")}
          </StyledDepositDesciption>
        )}
        {savedAccounts.length > 0 && !savedAccountsVisible && (
          <StyledFormRow>
            <DepositSavedAccount>
              <StyledButton btn type="button" onClick={savedAccountsOldCard}>
                {t(
                  isNlNewAccountAvailable()
                    ? "label_saved_account"
                    : "label_support_page"
                )}
              </StyledButton>
            </DepositSavedAccount>
          </StyledFormRow>
        )}
        {isQuickBetFirstDeposit() && (
          <FirstDepositBonusCodeDropdown
            register={register}
            skin={skin}
            errors={errors}
          />
          // <StyledFormRow>
          //   <StyledBankName>
          //     <label>{t("label_bonus_code")}</label>
          //     <StyledSelect
          //       {...register("bonusCode", {
          //         required: t("err_select_bonus_option"),
          //       })}
          //       name="bonusCode"
          //       /* defaultValue={t("label_select_bonus")} */
          //     >
          //       <option value="">{t("label_select_bonus")}</option>
          //       <option value={t("fdeposit-sports-bonus_code")}>
          //         {t("fdeposit-sports-bonus_title")}
          //       </option>
          //       <option value={t("fdeposit-bonus_code")}>
          //         {t("fdeposit-bonus_title")}
          //       </option>
          //       <option value="proceed">{t("fdeposit-no-bonus_title")}</option>
          //     </StyledSelect>
          //     <InvalidFeedback reg>{errors.bonusCode?.message}</InvalidFeedback>
          //   </StyledBankName>
          // </StyledFormRow>
        )}
        {depositType.depositType.indexOf("Bank Transfer") < 0 &&
          skin !== "nbc" &&
          isNlNewAccountAvailable() &&
          !isQuickBetFirstDeposit() && (
            <StyledFormRow>
              <StyledBonusCode>
                <label>{t("label_bonus_code")}</label>
                <StyledInput
                  bonus
                  type="text"
                  name="bonusCode"
                  {...register("bonusCode")}
                  defaultValue={
                    typeof bonusCode !== "undefined" && bonusCode !== ""
                      ? bonusCode
                      : ""
                  }
                ></StyledInput>
              </StyledBonusCode>
            </StyledFormRow>
          )}
        {depositType.depositType.indexOf("Bank Transfer") >= 0 && (
          <StyledBankTransfer>
            <StyledRow
              mt
              mb={"mb-3"}
              dangerouslySetInnerHTML={{ __html: t("bank_transfer_warning") }}
            >
              {/* {t("bank_transfer_warning")} */}
            </StyledRow>
            <StyledRow>
              <ColumnLeftAndRight left>
                {t("label_user_name")}
              </ColumnLeftAndRight>
              <ColumnLeftAndRight right>{playerData.email}</ColumnLeftAndRight>
              <ColumnLeftAndRight left>
                {t("label_user_ID_1")}
              </ColumnLeftAndRight>
              <ColumnLeftAndRight right>
                {playerData.nickName}
              </ColumnLeftAndRight>
            </StyledRow>
            <StyledRow mt mb={"mb-3"}>
              {t("label_account_in_malta")}
            </StyledRow>
            <StyledRow>
              <ColumnLeftAndRight left>
                {t("label_account_holder")}
              </ColumnLeftAndRight>
              <ColumnLeftAndRight
                right
                dangerouslySetInnerHTML={{ __html: t("bank_transfer_account") }}
              >
                {/* {t("bank_transfer_account")} */}
              </ColumnLeftAndRight>
              <ColumnLeftAndRight left>
                {t("label_bank_name")}
              </ColumnLeftAndRight>
              <ColumnLeftAndRight
                right
                dangerouslySetInnerHTML={{
                  __html: t("bank_transfer_bank_name"),
                }}
              >
                {/* {t("bank_transfer_bank_name")} */}
              </ColumnLeftAndRight>
              <ColumnLeftAndRight left>
                {t("label_bank_account_number")}
              </ColumnLeftAndRight>
              <ColumnLeftAndRight right>
                {t("bank_transfer_account_number")}
              </ColumnLeftAndRight>
              <ColumnLeftAndRight left>{t("label_iban")}</ColumnLeftAndRight>
              <ColumnLeftAndRight
                right
                dangerouslySetInnerHTML={{ __html: t("bank_transfer_iban") }}
              >
                {/* {t("bank_transfer_iban")} */}
              </ColumnLeftAndRight>
              <ColumnLeftAndRight left>{t("label_bic")}</ColumnLeftAndRight>
              <ColumnLeftAndRight right>
                {t("bank_transfer_bic")}
              </ColumnLeftAndRight>
            </StyledRow>
          </StyledBankTransfer>
        )}
        {/*{depositType.depositType.indexOf("PayPal PIQ") >= 0 && (*/}
        {/*  <StyledFormRow className={'mb-5 mt-1'}>*/}
        {/*    <StyledCustomCheckboxWrapper >*/}
        {/*      <StyledInput*/}
        {/*          customControl*/}
        {/*          type="checkbox"*/}
        {/*          onClick={() => saveOneClick(!oneClick)}*/}
        {/*          name="oneClick"*/}
        {/*          id="oneClick"*/}
        {/*          checked={oneClick}*/}
        {/*      />*/}
        {/*      <StyledCustomControlLabel htmlFor="oneClick">*/}
        {/*        {t("label_save_my_paypal", "Save my PayPal account for future use")}*/}
        {/*      </StyledCustomControlLabel>*/}
        {/*    </StyledCustomCheckboxWrapper>*/}
        {/*  </StyledFormRow>*/}
        {/*)}*/}
        <StyledFlexBetween>
          <StyledButton dialog pub={skin === "pub"} onClick={backAction}>
            {t("label_go_back")}
          </StyledButton>
          {depositType.depositType.indexOf("Bank Transfer") < 0 &&
            (depositType.depositType.indexOf("Boku") < 0 ||
              validatedDepositStart) &&
            isNlNewAccountAvailable() && (
              <StyledButton
                banktransfer
                pub={skin === "pub"}
                goldenborder="true"
                type="submit"
                name="submit"
              >
                {t("label_deposit")}
              </StyledButton>
            )}
          {depositType.depositType.indexOf("Boku") >= 0 &&
            !validatedDepositStart && (
              <StyledButton
                pub={skin === "pub"}
                goldenborder="true"
                banktransfer
                type="submit"
                name="validate"
              >
                {t("label_validate_amount", "label_validate_amount")}
              </StyledButton>
            )}
        </StyledFlexBetween>
        <StyledDepositDesciption>{t(description, "")}</StyledDepositDesciption>
      </StyledDepositDialog>

      <DepositStartingDialog
        showModal={showDepositStartingDialog}
        message={"message_eddsow_check"}
      />

      {fraudNetData.s !== "" && fraudNetData.f !== "" && oneClick && (
        <FraudNetScript s={fraudNetData.s} f={fraudNetData.f}></FraudNetScript>
      )}
    </>
  );
};

export default DepositDialog;
